import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { WizardHpModelFilterBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filter-base-component';
import { WizardHpModelFilterableBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filterable-base-component';
import { KeyValue } from '@angular/common';

export class WizardElementsFilterMenuComponent extends WizardHpModelFilterBaseComponent implements OnInit, OnDestroy {

  protected checkedStatus : any;
  rootKey:any;
  panelStyleOpenState = [];

  originalOrder = (a: KeyValue<number,any>, b: KeyValue<number,any>): number => {
    if (a.value.order > b.value.order) {
      return 1;
    } else if (a.value.order < b.value.order) {
      return -1;
    }
    return 0;
  }
  
  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {
    super(chgDetectorRef, hpService, router);
    
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.checkedStatus = {};

    if(this.getStoreSelectionInLocalStorage()) {
      var chkConfig = localStorage.getItem(this.getLocalStorageKey());
      if (chkConfig != null) {
        try {
          this.checkedStatus = {};  //JSON.parse(chkConfig);  //aucun filter selectionné par défaut       
        } catch (o) {
          this.checkedStatus = {};
        }
      }
    }
  }

  ngOnDestroy() : void {
    if (this.checkedStatus != null) {
      localStorage.setItem(this.getLocalStorageKey(), JSON.stringify(this.checkedStatus));
    }
  }

  getStoreSelectionInLocalStorage() {
    return false;
  }

  getLocalStorageKey() {
    return 'WizardElementsFilterMenuComponent';
  }

  getCheckStatus(elementId) {

    
    if (this.checkedStatus == null) {
      this.checkedStatus = {};
    }
    
    if (this.checkedStatus[elementId] != null){
      return this.checkedStatus[elementId];
    }
    return false;
  }

  onFilterByLibDataReceived(items) {
    this.options = items;
  }

  /*
    Capture de l'evenement lorsque l'un des checkbox / radio button est modifié.
  */
  filterChange(event, elementId, callBackParams, groupName) {

    var modConfig = this.modele_filter;
    var ruleTxt = '';

    var group_add_type = null;
    var single_add_type = null;
    var currentIsChecked = false;
    if(event != null && event.checked != null) {
      currentIsChecked = event.checked;
      this.checkedStatus[elementId] = currentIsChecked;
    }

    //d'abord on décoche les checkboxes du meme groupe.
    if (currentIsChecked) {
      if (groupName != null) {
        for (var k in modConfig) {
          if (k == groupName) {
            var o = modConfig[k];
            var filterId = null;
            for (var l in o.items) {
              var id = o.items[l].id;
              
              if(elementId != id) {
                if (this.checkedStatus == null) {
                  this.checkedStatus = {};
                }
                this.checkedStatus[id] = false;
              }
            }
            break;
          }
        }
      }
    }

    for (var k in modConfig) {

      var o = modConfig[k];

      group_add_type = o.group_add_type;
      single_add_type = o.single_add_type;

      var subRuleTxt = '';
      for (var l in o.items) {
        var id = o.items[l].id;
        var isChecked = false;
        if (this.checkedStatus[id] != null){
          isChecked = this.checkedStatus[id];
        }
        if (isChecked && o.items[l].keywords != null && o.items[l].keywords != '') {
            subRuleTxt += o.items[l].keywords + single_add_type;
        }
      }
      if (subRuleTxt != '') {

        if (subRuleTxt != '') {
    
          subRuleTxt = subRuleTxt.substring(0, subRuleTxt.length - single_add_type.length);
       
          subRuleTxt = '(' + subRuleTxt + ')';
       
        }

        if (ruleTxt == '') {
          ruleTxt = subRuleTxt;
        } else {
          ruleTxt += group_add_type + subRuleTxt;
        }
      }
    }
    this.setFilter(ruleTxt, null, this.onFilterChangeDataReceived, callBackParams);
    
    this.getHpService().emitDataChange(); 
    this.getChangeDetectorRef().detectChanges();
  }

  onFilterChangeDataReceived(result: any) {

    if (this.getFilterable() != null) {
      this.getFilterable().onDataRetrieved(result);
    }
    this.getHpService().emitDataChange(); 
    this.getChangeDetectorRef().detectChanges();
  }

  setFilterKeyword(cat,keyword)
  {
    console.log('setFilterKeyword', keyword);
    if(cat === "cat-mat")
      {
        this.getHpService().setFilterKeyword(keyword);
      }
    
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();

  }



  setRootkey(key: any) {
    this.rootKey = key;
  }


  displayInfoAnswer(keyword: string) {

    if(!this.getHpService().getConfig().herculepro.answerMenu_info)
    {
      return -1
    }
    const showed = (element) => element.code === keyword;
    return this.getHpService().getConfig().herculepro.answerMenu_info.findIndex(showed)
  }



}
